import ChatComponent from "../../../components/chat-component";
import TwoColumnLayOut from "../../../layouts/two-columns/two-column-layout";
import ContactUsComponent from "./components/index.component";

const ContactUs = () => {
  const path = "Who-We-Are%2FContact-Us";

  return (
    <>
      <TwoColumnLayOut breadcrumbPath={path} isBreadcrumbpath={true} showAds={true}>
        <ContactUsComponent />
        <ChatComponent />
      </TwoColumnLayOut>
    </>
  );
};

export default ContactUs;
